/** @jsxImportSource @emotion/react */
import React from "react";
import { Alert, Col, Modal, Row, Button, Typography } from "antd";
import * as Styles from "./styles";
import { HomeUsecase, useHomeDispatch } from "../../../usecases/Home";
import { GetHomeDto } from "../../../services/Home/dto/get.dto";

interface ModalDeleteRequestHomeProps {
  onCancel: () => void;
  onSuccess: () => void;
  visible: boolean;
  item: GetHomeDto;
}

const ModalDeleteRequestHomeComponent: React.FC<ModalDeleteRequestHomeProps> =
  ({ visible, onCancel, onSuccess, item }: ModalDeleteRequestHomeProps) => {
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const HomeDispatch = useHomeDispatch();

    const onButtonSubmitClickHandle = React.useCallback(async () => {
      setIsProcessing(true);
      try {
        if (HomeDispatch) {
          const homeUsecase = new HomeUsecase(HomeDispatch);
          await homeUsecase.delete(item.id);
        }
        setErrorMessage("");
        onSuccess();
      } catch (error) {
        console.error(error);
        setErrorMessage(error.message);
      } finally {
        setIsProcessing(false);
      }
    }, [HomeDispatch, item.id, onSuccess]);

    const onCancelHandle = React.useCallback(() => {
      setErrorMessage("");
      onCancel();
    }, [onCancel]);

    return (
      <Modal
        title="Delete Request"
        visible={visible}
        closable={false}
        footer={[
          <Button key="back" size="large" onClick={onCancelHandle}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger
            size="large"
            loading={isProcessing}
            onClick={onButtonSubmitClickHandle}
          >
            Delete
          </Button>,
        ]}
      >
        {errorMessage && (
          <Row justify="center">
            <Col css={Styles.colGutterStyle}>
              <Alert message={errorMessage} type="error" />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Typography>Are you sure to this request?</Typography>
          </Col>
        </Row>
      </Modal>
    );
  };

export const ModalDeleteRequestHome = React.memo(
  ModalDeleteRequestHomeComponent,
);
